import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { getUrlParams } from "../apiService/timespam";
import "./Theme.css";
import "./NHSEczemaProgram.css";

const NHSEczemaProgramSummery = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  return (
    <section className="nhs-page">
      <motion.div
        className="nhs-container"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="nhs-success-icon"
        >
          &#10003;
        </motion.div>
        <motion.h1
          className="nhs-thank-title"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          {t("nhsProgram.thankYouTitle")}
        </motion.h1>
        <motion.p
          className="nhs-thank-subtitle"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          {t("nhsProgram.thankYouSubtitle")}
        </motion.p>
      </motion.div>
    </section>
  );
};

export default NHSEczemaProgramSummery;
